import { createSlice } from '@reduxjs/toolkit';
import {
  MessageLocationDataType,
  MessageSignagesDataType,
  MessageTrainsDataType
} from '../../pages/NoticeMessageList';

export interface MessageStateType {
  id: number;
  alert_level: number;
  category_id: number;
  category_name: string;
  message: string;
  term_from: string;
  term_to: string;
  type: number;
  messageSignagesData: MessageSignagesDataType | null;
  messageTrainsData: Array<MessageTrainsDataType> | null;
  messageLocationData: MessageLocationDataType | null;
}

export const initStateData: MessageStateType = {
  id: 0,
  alert_level: 0,
  category_id: 0,
  category_name: '',
  message: '',
  term_from: '',
  term_to: '',
  type: 0,
  messageSignagesData: null,
  messageTrainsData: null,
  messageLocationData: null
};

const MessageSlice = createSlice({
  name: 'message',
  initialState: {
    value: {
      data: initStateData
    }
  },
  reducers: {
    SetMessageData: (state, action) => {
      state.value = action.payload;
    }
  }
});

export const { SetMessageData } = MessageSlice.actions;
export default MessageSlice.reducer;
